export default __webpack_public_path__ + "static/media/85_desktop.4dc1bcea.jpg";